import { TYRE_PROPERTIES } from 'store/enums';

// Check if object is empty
export const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;

// Get field of objects and arrays
export const fetchFromObject = (obj, prop) => {
  if (typeof obj === 'undefined') return false;
  const index = prop.indexOf('.');
  if (index > -1) {
    return fetchFromObject(obj[prop.substring(0, index)], prop.substr(index + 1));
  }
  return obj[prop];
};

// Set value in field at objects and arrays
export const setValueObjectByField = (obj, prop, value) => {
  if (typeof obj !== 'undefined' && prop) {
    const index = prop.indexOf('.');

    if (index > -1) {
      const key = prop.substring(0, index);

      // Si el objeto no tiene la clave, crear un nuevo objeto en esa posición
      if (typeof obj[key] === 'undefined') {
        // eslint-disable-next-line no-param-reassign
        obj[key] = {};
      }

      // Continuar de forma recursiva para la siguiente parte del path
      setValueObjectByField(obj[key], prop.substr(index + 1), value);
    } else {
      // Asigna el valor cuando se llega al nivel más bajo del path
      // eslint-disable-next-line no-param-reassign
      obj[prop] = value;
    }
  }
};

export const mapArraryMasterData = data =>
  data.map(item => ({ label: item.label, value: item.value }));

export const checkIncludeArray = (includeMe, needInclusions) => {
  let someFlag = true;
  for (let i = 0; i < needInclusions.length; i += 1) {
    if (includeMe.indexOf(needInclusions[i]) === -1) {
      someFlag = false;
      break;
    }
  }
  return someFlag;
};

export const isNil = value => value === null || value === undefined;

export const isEmpty = value => value === '';

/**
 * Prepara opciones para un select
 * @param {Array<{id: number, name: string}>} options - Opciones a preparar
 * @returns {Array<{ value: string, label: string }>} - Opciones preparadas
 */
export const mapOptionsMasterData = options =>
  options.map(item => ({
    ...item,
    value: item.id.toString(),
    label: item.name
  }));

/**
 * Añade las propiedades necesarias para el buen funcionamiento de la carga  de los neumáticos en el acta.
 * @param {Object} data - Acta
 * @param {Boolean} insideVariable - Especifica si tiene que operar dentro de variable o en la raíz del objeto.
 * @returns {Object} - Acta con las propiedades añadidas si hubiese sido necesario
 */
export const ensureTyreProperties = ({ data, insideVariable = true }) => {
  const newData = insideVariable ? { ...data, variable: { ...data.variable } } : { ...data };
  const target = insideVariable ? newData.variable : newData;
  TYRE_PROPERTIES.forEach(prop => {
    if (!(prop in target)) {
      target[prop] = null;
    }
  });
  return newData;
};
